import { AccesosOrganizacionModal } from "../AccesosOrganizacion/AccesosOrganizacionModal";
import type { UsuarioFormCamposProps } from "./UsuarioFormCampos.types";

const TIPOS = { grupo: "Simple", organizacion: "Por organización" }

// Compañía, sucursal y sedes del usuario: en el formulario solo queda el resumen y
// el botón; la edición vive en el modal "Accesos por organización", que permite la
// configuración simple de siempre o la configuración por organización. Compañía y
// sucursal siguen registradas en react-hook-form (inputs ocultos, `required`).
export const UsuarioFormOrganizacion = ({
    register, errors, watch, listaCompanias, listaSucursales,
    sedesSeleccionadas, errorSedes, accesos,
}: UsuarioFormCamposProps) => {
    const compania = `${watch("compania") ?? ""}`
    const sucursal = `${watch("sucursal") ?? ""}`
    const nombreCompania = (listaCompanias || []).find((c) => `${c?.id}` === compania)?.tipo || compania || "-"
    const nombreSucursal = (listaSucursales || []).find((s) => `${s?.CompCod}` === sucursal)?.CompNom || sucursal || "-"
    const principal = sedesSeleccionadas?.[0]?.label
    const total = sedesSeleccionadas?.length || 0
    // En la configuración simple el grupo puede dar acceso a más sedes que las asignadas.
    const porGrupo = accesos.sedesQueVe !== null && accesos.sedesQueVe > total
        ? ` · por su grupo ve ${accesos.sedesQueVe} sede(s)` : ""

    return (
        <div className="col-12">
            <input type="hidden" {...register("compania", { required: { value: true } })} />
            <input type="hidden" {...register("sucursal", { required: { value: true } })} />
            <div className="tw-rounded tw-border tw-border-gray-200 tw-p-2 tw-text-sm">
                <div><span className="tw-text-gray-500">Compañía:</span> {nombreCompania}</div>
                <div><span className="tw-text-gray-500">Sucursal:</span> {nombreSucursal}</div>
                <div><span className="tw-text-gray-500">Sede principal:</span> {principal || "-"}</div>
                <div><span className="tw-text-gray-500">Accesos:</span> {TIPOS[accesos.modo]} · {total} sede(s){porGrupo}</div>
                <button type="button" className="btn btn-sm btn-primario tw-mt-2" onClick={accesos.abrir}>Accesos por organización</button>
            </div>
            {(errors.compania || errors.sucursal) && <p role="alert" className="error px-2 mb-0">Ingrese compañía y sucursal</p>}
            {errorSedes && <p role="alert" className="error px-2 mb-0">Seleccione al menos una sede</p>}
            <AccesosOrganizacionModal acc={accesos} />
        </div>
    )
}
